import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = ['Prueba y error constante con materiales caros', 'Soldaduras frágiles que se rompen al moverlo', 'Cables a la vista que arruinan la estética', 'No sabe cómo cobrar y termina perdiendo plata', 'Carteles que parpadean o se queman rápido'];
  const goodPoints = ['Sigue un método paso a paso profesional', 'Soldadura impecable y conexiones seguras', 'Cableado invisible y terminaciones premium', 'Sabe calcular costos y vende con alto margen', 'Carteles duraderos con garantía de calidad'];
  return <section className="py-24 px-4 relative z-10 bg-transparent pt-[50px] pb-[50px]" data-id="element-147">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#1a0b2e]/40 border border-white/5 rounded-[2.5rem] p-10 md:p-12" data-id="element-149">
          <div className="mb-10 border-b border-white/5 pb-8" data-id="element-150">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 text-red-400 text-xs font-black mb-4 tracking-widest" data-id="element-151">
              <XIcon className="w-4 h-4" data-id="element-152" /> EL AFICIONADO
            </div>
            <h3 className="text-3xl font-black text-white mb-4" data-id="element-153">
              Sin Capacitación
            </h3>
            <p className="text-gray-400 text-lg font-medium" data-id="element-154">
              Pierde tiempo, materiales y clientes por falta de técnica.
            </p>
          </div>
          <ul className="space-y-6" data-id="element-155">
            {badPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-500" data-id="element-156">
                <div className="bg-red-500/10 p-2 rounded-xl shrink-0 mt-1" data-id="element-157">
                  <XIcon className="w-4 h-4 text-red-400" data-id="element-158" />
                </div>
                <span className="text-lg leading-relaxed font-[700] text-[#B0B0B5]" data-id="element-159">
                  {point}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#1a0b2e]/60 border border-[#00f0ff]/30 rounded-[2.5rem] p-10 md:p-12 relative overflow-hidden shadow-[0_0_50px_rgba(0,240,255,0.1)]" data-id="element-160">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#00f0ff]/10 rounded-full blur-[80px]" data-id="element-161" />

          <div className="mb-10 border-b border-white/5 pb-8 relative z-10" data-id="element-162">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00f0ff]/10 text-[#00f0ff] text-xs font-black mb-4 tracking-widest" data-id="element-163">
              <CheckIcon className="w-4 h-4" data-id="element-164" /> EL PROFESIONAL
            </div>
            <h3 className="text-3xl font-black text-white mb-4" data-id="element-165">
              Con Nuestra Maestría
            </h3>
            <p className="text-gray-300 text-lg font-medium" data-id="element-166">
              Crea piezas de lujo y construye un negocio sólido.
            </p>
          </div>
          <ul className="space-y-6 relative z-10" data-id="element-167">
            {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-white" data-id="element-168">
                <div className="bg-[#00f0ff]/10 p-2 rounded-xl shrink-0 mt-1 shadow-[0_0_10px_rgba(0,240,255,0.3)]" data-id="element-169">
                  <CheckIcon className="w-4 h-4 text-[#00f0ff]" data-id="element-170" />
                </div>
                <span className="text-lg font-bold leading-relaxed" data-id="element-171">
                  {point}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}